import { makeApolloClient, logError } from '../util';
import { PODCASTS, PODCAST } from 'queries/podcasts';
import {
	FETCH_PODCASTS,
	FETCH_PODCAST,
	CREATE_PODCAST,
	UPDATE_PODCAST,
	DELETE_PODCAST,
	CLEAR_PODCAST,
	CLEAR_PODCASTS,
} from './actionTypes';

export const fetchPodcasts = (podcasts, from) => ({
	type: FETCH_PODCASTS,
	podcasts,
	from,
});

export const fetchPodcast = (podcast, from) => ({
	type: FETCH_PODCAST,
	podcast,
	from,
});

export const createPodcast = (podcast, from) => ({
	type: CREATE_PODCAST,
	podcast,
	from,
});

export const updatePodcast = (podcast, from) => ({
	type: UPDATE_PODCAST,
	podcast,
	from,
});

export const deletePodcast = ({ deletePodcast }, from) => ({
	type: DELETE_PODCAST,
	from,
	podcastID: deletePodcast.id,
});

export const clearPodcasts = from => ({
	type: CLEAR_PODCASTS,
	from,
});

export const clearPodcast = from => ({
	type: CLEAR_PODCAST,
	from,
});

export const updatePodcastListens = ({ updatePodcastListens }, from) => ({
	type: UPDATE_PODCAST,
	podcast: updatePodcastListens,
	from,
});

export const thunkFetchPodcasts = ({ event_id }, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { podcasts } = await client.request(PODCASTS, {
			event_id,
		});
		dispatch(fetchPodcasts(podcasts, from));
	} catch (error) {
		logError(error, 'podcasts.actions.thunkFetchPodcasts');
	}
};

export const thunkFetchPodcast = (podcastID, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { podcast } = await client.request(PODCAST, {
			id: podcastID,
		});
		dispatch(fetchPodcast(podcast, from));
	} catch (error) {
		logError(error, 'podcasts.actions.thunkFetchPodcast');
	}
};

// for future use (fetching pinned podcast outside of podcast route - like homescreen widgets)

// export const thunkFetchPinnedPodcasts = (eventID, from) => async (dispatch, getState) => {
// 	const client = makeApolloClient(getState());
// 	try {
// 		const { pinnedPodcasts } = await client.request(PINNED_PODCASTS, {
// 			event_id: eventID,
// 		});
// 		dispatch(setPinnedPodcasts(pinnedPodcasts, from));
// 	} catch (error) {
// 		logError(error, 'pinned.actions.fetchPinnedPodcasts');
// 	}
// };
